import {Component, Input, OnInit} from '@angular/core';
import {User, UserManagementModel} from './user-management.model';
import {UserManagementService} from './user-management.service';
import {TokenManagerService} from '../shared/services/token-login.service';
import {GroupDetailsVenueModel} from "../venues/create-group/create-group.model";


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  providers: [UserManagementService],
  styleUrls: ['./user-management.component.less']
})
export class UserManagementComponent implements OnInit {
  @Input() dataSource: Array<User>;
  @Input() groupId: boolean;
  @Input() venues: GroupDetailsVenueModel[];
  @Input() managerAdmin: boolean;

  showUserDetails = false;
  deleteUserConfirmation = false;
  addNewUser = false;
  userId: number;
  showInfoSearch = false;
  index: number;
  isUserAdmin: boolean;
  searchFilter: string;

  startIndex: number;
  endIndex: number;

  users: User[];
  activeUser = new User();
  userManagementModel = new UserManagementModel();

  constructor(private userManagementService: UserManagementService) {
  }

  ngOnInit() {
    this.init();
  }

  editUser(user, index) {
    this.index = index;
    this.activeUser = user;
    this.showUserDetails = true;
    console.log(this.index);
  }

  confirmDelete(id, index) {
    this.index = index;
    this.deleteUserConfirmation = true;
    this.userId = id;
  }

  addUser() {
    this.addNewUser = true;
  }

  searchUsers(query) {
    if (query) {
      this.userManagementService.searchNightkeyUsers(query, 1, this.userManagementModel.pageSize, '', true)
        .subscribe(
          (response) => {
            this.userManagementModel = response;
            if (this.userManagementModel.users.length === 0) {
              this.showInfoSearch = true;
            } else {
              this.showInfoSearch = false;
            }
          },
          (error) => console.log(error)
        );
    } else {
      this.showInfoSearch = false;
      this.userManagementModel.page = 1;
      this.init();
    }
  }

  init() {
    this.isUserAdmin = TokenManagerService.isAdmin() || this.managerAdmin;
    if (this.dataSource) {
      this.getUsersByGroup();
    } else {
      this.getUsers();
    }
  }

  getUsers() {
    this.userManagementService.getNightKeyUsers(this.userManagementModel.page, this.userManagementModel.pageSize, '', true)
      .subscribe(
        (response) => {
          this.userManagementModel = response;
        },
        (error) => console.log(error)
      );
  }

  getUsersByGroup() {
    this.users = this.dataSource;
    this.userManagementModel.pageSize = this.dataSource.length;
    this.userManagementModel.totalCount = this.dataSource.length;
    this.userManagementModel.totalPages = 1;
    // this.userManagementService.
    // getNightKeyUsersByGroup(this.groupId)
    //   .subscribe(
    //     (response) => {
    //       this.userManagementModel.users = response;
    //
    //       this.userManagementModel.totalCount = this.userManagementModel.users.length;
    //       this.userManagementModel.pageSize = 8;
    //       this.userManagementModel.totalPages = Math.ceil(this.userManagementModel.totalCount / this.userManagementModel.pageSize);
    //
    //       this.showPage(1);
    //     },
    //     (error) => console.log(error)
    //   );
  }

  showPage(page: number) {
    this.userManagementModel.page = page;
    if (this.dataSource) {
     /* this.userManagementModel.users.splice(page * (this.userManagementModel.pageSize - 1), this.userManagementModel.users.length - 1);
      this.getUsersByGroup();
      this.userManagementModel.users.slice(page * (this.userManagementModel.pageSize - 1),
      page * (this.userManagementModel.pageSize - 1));*/

      this.startIndex = (page - 1) * this.userManagementModel.pageSize;
      this.endIndex = Math.min(this.startIndex + this.userManagementModel.pageSize - 1, this.userManagementModel.totalCount - 1);

      this.users = this.userManagementModel.users.slice(this.startIndex, this.endIndex + 1);
    } else {
      this.getUsers();
    }
  }

  updateListAdd(e) {
    if (e === 'userManagement') {
      this.init();
    } else {
      this.users.unshift(e);
    }
  }

  updateListDelete(e) {
    if (e === 'groupProfileDelete') {
      this.users.splice(this.index, 1);
    } else {
      this.init();
    }
  }

  updateListEdit(e) {
    if (e === 'userManagement') {
      this.init();
    } else {
      console.log(this.index);
      this.activeUser = e;
      console.log(this.activeUser);
      this.users[this.index] = this.activeUser;
    }
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/user-management.component.ts